import React from 'react'

function TechSelectHepa() {
  return (
    <embed src="\pdfs\E3.1.1_hepa_h13_07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectHepa